module.exports = __webpack_public_path__ + "static/media/lupin.1569950f.svg";